(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-bulk-order"] && !Shopify.designMode) return;
  try {
    
    class BulkOrderList extends HTMLElement {
        constructor() {
            super();

            try {
                this.form = this.querySelector('#BulkOrderList');
                this.quantityInputs = this.querySelectorAll('.quantity-input');
                this.totalItemsElement = this.querySelector('.bulk-order-list__total-items');
                this.totalPriceElement = this.querySelector('.bulk-order-list__total-price');
                this.addAllButton = this.querySelector('.bulk-order-list__add-all');
                this.cartDrawer = document.querySelector('cart-drawer');

                this.shouldShowPrices = this.dataset.shouldHideForSpecificB2b !== 'true';
                this.shouldHideForSpecificB2b = this.dataset.shouldHideForSpecificB2b === 'true';

                this.state = {
                    totals: {
                        items: 0,
                        price: 0
                    },
                    isLoading: false
                };

                if (this.form) {
                    this.initializeEventListeners();
                    this.updateTotals();
                }
            } catch (error) {
                console.error('Error initializing BulkOrderList:', error);
            }
        }

        initializeEventListeners() {
            if (!this.form) return;
            


            this.quantityInputs.forEach(input => {
                const minusButton = input.previousElementSibling;
                const plusButton = input.nextElementSibling;

                if (minusButton) {
                    minusButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.updateQuantity(input, -1);
                    });
                }

                if (plusButton) {
                    plusButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.updateQuantity(input, 1);
                    });
                }

                input.addEventListener('change', () => {
                    this.validateInput(input);
                    this.updateTotals();
                });

                input.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        this.validateInput(input);
                        this.updateTotals();
                    }
                });
            });

            this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        validateInput(input) {
            const value = parseInt(input.value, 10);
            const maxQuantity = parseInt(input.dataset.inventoryQuantity, 10) || 999;

            if (isNaN(value) || value < 0) {
                input.value = 0;
            } else if (value > maxQuantity) {
                input.value = maxQuantity;
            }
        }

        updateQuantity(input, change) {
            const currentValue = parseInt(input.value, 10) || 0;
            const maxQuantity = parseInt(input.dataset.inventoryQuantity, 10) || 999;
            const newValue = Math.max(0, Math.min(maxQuantity, currentValue + change));

            input.value = newValue;
            this.validateInput(input);
            input.dispatchEvent(new Event('change', {bubbles: true}));
        }

        updateTotals() {
            let totalItems = 0;
            let totalPrice = 0;

            this.quantityInputs.forEach(input => {
                const quantity = parseInt(input.value, 10) || 0;
                const priceInCents = parseInt(input.dataset.variantPrice, 10) || 0;
                const itemTotal = quantity * priceInCents;

                totalItems += quantity;
                totalPrice += itemTotal;

                const minusButton = input.previousElementSibling;
                const plusButton = input.nextElementSibling;
                const maxQuantity = parseInt(input.dataset.inventoryQuantity, 10) || 999;

                if (minusButton && minusButton.classList.contains('minus')) {
                    minusButton.disabled = quantity === 0;
                }

                if (plusButton && plusButton.classList.contains('plus')) {
                    plusButton.disabled = quantity >= maxQuantity;
                }

                if (this.shouldShowPrices && !this.shouldHideForSpecificB2b) {
                    const row = input.closest('tr.bulk-order-item');
                    if (row) {
                        const totalCell = row.querySelector('td[role="cell"]:last-child span.price');
                        if (totalCell) {
                            const formattedTotal = this.formatMoney(itemTotal);
                            totalCell.textContent = formattedTotal;
                        }
                    }
                }
            });

            this.state.totals = {
                items: totalItems,
                price: totalPrice
            };

            if (this.totalItemsElement) {
                this.totalItemsElement.textContent = totalItems;
            }

            if (this.totalPriceElement && this.shouldShowPrices && !this.shouldHideForSpecificB2b) {
                this.totalPriceElement.textContent = this.formatMoney(totalPrice);
            }

            if (this.addAllButton) {
                this.addAllButton.disabled = totalItems === 0;
            }
        }

        formatMoney(amount) {
            if (!amount || amount === 0) {
                return '0,00 €';
            }

            const dollars = amount / 100;

            const formattedAmount = new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(dollars);

            return formattedAmount + ' €';
        }

        setLoadingState(isLoading) {
            this.state.isLoading = isLoading;
            if (this.form) {
                this.form.classList.toggle('bulk-order-list--loading', isLoading);
            }
            if (this.addAllButton) {
                this.addAllButton.disabled = isLoading;
                this.addAllButton.classList.toggle('is-loading', isLoading);
            }
        }

        async handleSubmit(event) {
            event.preventDefault();

            if (this.state.isLoading) return;
            


            const items = [];
            for (const input of this.quantityInputs) {
                const quantity = parseInt(input.value, 10) || 0;
                const variantId = parseInt(input.dataset.variantId, 10);

// Validate data before adding
                if (quantity > 0 && !isNaN(variantId) && variantId > 0) {
                    items.push({id: variantId.toString(), quantity: quantity});
                    console.log(`Adding item: variant ${variantId}, quantity ${quantity}`);
                } else {
                    console.warn(`Skipping invalid item: variant ${variantId}, quantity ${quantity}`);
                }
            }

            if (items.length === 0) {
                console.log('No valid items to add to cart');
                return;
            }

// Debug: Log the items being sent
            console.log('Items to add to cart:', items);

            this.setLoadingState(true);

            try { // First, get current cart to check for existing items
                const cartResponse = await fetch('/cart.js');
                let currentCart = {
                    items: []
                };

                if (cartResponse.ok) {
                    currentCart = await cartResponse.json();
                    console.log('Current cart:', currentCart);
                }

// Merge quantities with existing cart items
                const mergedItems = [... items];

                for (const newItem of items) {
                    const existingItem = currentCart.items.find(item => item.variant_id.toString() === newItem.id);
                    if (existingItem) { // Update quantity instead of adding new item
                        const existingIndex = mergedItems.findIndex(item => item.id === newItem.id);
                        if (existingIndex !== -1) {
                            mergedItems[existingIndex].quantity = existingItem.quantity + newItem.quantity;
                            console.log(`Merging quantities for variant ${
                                newItem.id
                            }: existing ${
                                existingItem.quantity
                            } + new ${
                                newItem.quantity
                            } = ${
                                mergedItems[existingIndex].quantity
                            }`);
                        }
                    }
                }

                const requestBody = {
                    items: mergedItems
                };
                console.log('Request body (merged):', requestBody);

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(requestBody)
                });

                console.log('Response status:', response.status);
                console.log('Response headers:', response.headers);

                if (! response.ok) {
                    const errorText = await response.text();
                    console.error('Response error text:', errorText);

// If it's a quantity limit error, try adding items one by one
                    if (response.status === 422 && errorText.includes('maximale Menge')) {
                        console.log('Quantity limit reached, trying to add items individually...');

                        let successCount = 0;
                        for (const item of mergedItems) {
                            try {
                                const individualResponse = await fetch('/cart/add.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Accept': 'application/json',
                                        'X-Requested-With': 'XMLHttpRequest'
                                    },
                                    body: JSON.stringify(
                                        {items: [item]}
                                    )
                                });

                                if (individualResponse.ok) {
                                    successCount++;
                                    console.log(`Successfully added variant ${
                                        item.id
                                    }`);
                                } else {
                                    console.warn(`Failed to add variant ${
                                        item.id
                                    }: ${
                                        individualResponse.status
                                    }`);
                                }
                            } catch (individualError) {
                                console.warn(`Error adding variant ${
                                    item.id
                                }:`, individualError);
                            }
                        }

                        if (successCount > 0) {
                            console.log(`Successfully added ${successCount} out of ${
                                mergedItems.length
                            } items`);

// Continue with success flow
                        } else {
                            throw new Error('Failed to add any items to cart due to quantity limits');
                        }
                    } else {
                        throw new Error(`Failed to add items to cart: ${
                            response.status
                        } - ${errorText}`);
                    }
                }

                const data = await response.json();

                this.quantityInputs.forEach(input => input.value = 0);
                this.updateTotals();

                if (window.theme && typeof window.theme === 'object') {
                    window.theme.cart = data;
                }

                try {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: {
                            cart: data
                        }
                    }));
                } catch (eventError) {
                    console.warn('Could not dispatch cart:refresh event:', eventError);
                }

                if (this.cartDrawer && typeof this.cartDrawer.setAttribute === 'function') {
                    this.cartDrawer.setAttribute('open', '');
                } else {
                    sessionStorage.setItem('shouldOpenCart', 'true');
                    window.location.href = '/';
                }

            } catch (error) {
                console.error('Error adding items to cart:', error);
                alert('Fehler beim Hinzufügen der Artikel zum Warenkorb. Bitte versuchen Sie es erneut.');
            } finally {
                this.setLoadingState(false);
            }
        }
    }

    if (!customElements.get('bulk-order-list')) {
        try {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => {
                    try {
                        customElements.define('bulk-order-list', BulkOrderList);
                    } catch (defineError) {
                        console.warn('Could not define bulk-order-list custom element:', defineError);
                    }
                });
            } else {
                try {
                    customElements.define('bulk-order-list', BulkOrderList);
                } catch (defineError) {
                    console.warn('Could not define bulk-order-list custom element:', defineError);
                }
            }
        } catch (error) {
            console.error('Error registering bulk-order-list custom element:', error);
        }
    }

  } catch(e) { console.error(e); }
})();
})();
